export const TEST_ID = 'serviceLogHistory';

export const SKELETON_LINES = 6;
